import { render, staticRenderFns } from "./JoszakiInputOld.vue?vue&type=template&id=5f716d80"
import script from "./JoszakiInputOld.vue?vue&type=script&lang=js"
export * from "./JoszakiInputOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports